module.exports = __webpack_public_path__ + "img/202509-2_01_sp.fba5b152.jpg";